import React from "react";

import EventFilter from "./EventFilter";
import EventSearch from "./EventSearch";

const EventFilters = ({ filters, activeFilters, changeFilters }) => {
    const updateFilters = (slug, value) => {
        let newActiveFilters = { ...activeFilters };

        newActiveFilters[slug] = value;

        changeFilters(newActiveFilters);
    };

    return (
        <form className="event-overview__form">
            <fieldset>
                {filters.map(filter => (
                    <label htmlFor={filter.slug} className="event-overview__label" key={filter.slug}>
                        <span className="visually-hidden">{filter.title}</span>
                        {filter.type === "query" ? (
                            <EventSearch
                                filter={filter}
                                activeSearch={activeFilters[filter.slug]}
                                updateFilters={updateFilters}
                            />
                        ) : (
                            <>
                                {Object.keys(filter.options).length > 0 && (
                                    <EventFilter
                                        filter={filter}
                                        activeFilter={activeFilters[filter.slug]}
                                        updateFilters={updateFilters}
                                    />
                                )}
                            </>
                        )}
                    </label>
                ))}
            </fieldset>
        </form>
    );
};

export default EventFilters;
